import { stringSearch, useSetSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import ProjectOverviewPage from '@/areas/projects/ProjectOverview/ProjectOverviewPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/projects/')({
    // The navbar hides the entry from customers on the hosts without customer RfQs, who work from Assemblies and
    // Orders. The list stays open by URL on purpose.
    staticData: { access: { permissions: ['view:rfq'] }, chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ view: 'optional', rfqId: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const view = Route.useSearch({ select: (search) => search.view });
    const rfqId = Route.useSearch({ select: (search) => search.rfqId });
    const setSearch = useSetSearch();
    return <ProjectOverviewPage view={view} rfqId={rfqId} onSearchChange={setSearch} />;
}
